import React from "react";
import ScrollReveal from "@/components/ScrollReveal";

export default function PullQuote({ text, attribution, bg = "emerald" }) {
  const isEmerald = bg === "emerald";
  return (
    <section
      data-testid="pullquote-section"
      className={`relative overflow-hidden ${isEmerald ? "text-ivory" : "text-charcoal"}`}
      style={{ backgroundColor: isEmerald ? "var(--color-emerald)" : "var(--color-pearl)" }}
    >
      <div className={`pointer-events-none absolute inset-x-0 top-0 h-px ${isEmerald ? "bg-brass/30" : "bg-brass/40"}`} aria-hidden />
      <div className={`pointer-events-none absolute inset-x-0 bottom-0 h-px ${isEmerald ? "bg-brass/30" : "bg-brass/40"}`} aria-hidden />
      <div className="mx-auto max-w-5xl px-6 md:px-10 py-28 md:py-36 text-center">
        <ScrollReveal>
          <blockquote
            className="leading-[1.18] text-balance"
            style={{ fontSize: "clamp(1.75rem, 3.8vw, 2.85rem)", fontFamily: '"Cormorant Garamond", serif', fontStyle: "italic", fontWeight: 400 }}
          >
            &ldquo;{text}&rdquo;
          </blockquote>
        </ScrollReveal>
        <ScrollReveal delay={180}>
          <div className="mt-9 flex items-center justify-center gap-4">
            <span className="brass-rule" style={{ width: 36 }} />
            <span className="eyebrow text-brass">{attribution}</span>
            <span className="brass-rule" style={{ width: 36 }} />
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
